import { useTheme } from "@hooks";

export const Search = () => {
  const { theme } = useTheme();

  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.1917 29.7144L18.8771 20.3998C18.1687 21.0137 17.3424 21.4918 16.3979 21.8341C15.4535 22.1765 14.45 22.3477 13.3875 22.3477C10.8375 22.3477 8.67708 21.4623 6.90625 19.6914C5.13542 17.9206 4.25 15.7838 4.25 13.281C4.25 10.7782 5.13542 8.64144 6.90625 6.87061C8.67708 5.09977 10.8257 4.21436 13.3521 4.21436C15.8549 4.21436 17.9858 5.09977 19.7448 6.87061C21.5038 8.64144 22.3833 10.7782 22.3833 13.281C22.3833 14.2963 22.2181 15.2762 21.8875 16.2206C21.5569 17.1651 21.0611 18.0505 20.4 18.8769L29.75 28.156L28.1917 29.7144ZM13.3521 20.2227C15.2646 20.2227 16.8937 19.5439 18.2396 18.1862C19.5854 16.8286 20.2583 15.1935 20.2583 13.281C20.2583 11.3685 19.5854 9.73345 18.2396 8.37581C16.8937 7.01817 15.2646 6.33936 13.3521 6.33936C11.416 6.33936 9.7691 7.01817 8.41146 8.37581C7.05382 9.73345 6.375 11.3685 6.375 13.281C6.375 15.1935 7.05382 16.8286 8.41146 18.1862C9.7691 19.5439 11.416 20.2227 13.3521 20.2227Z"
        fill={theme.icon.default}
      />
    </svg>
  );
};
